import { NgModule } from '@angular/core';

import { HisDynamicFormSharedModule } from './his-dynamicform-shared.module';

/**
 * CoreModule for common components.
 */
@NgModule( {
    imports: [
        HisDynamicFormSharedModule,
    ],

    declarations: [
    ],

    exports: [
        HisDynamicFormSharedModule
    ]
} )

export class HisDynamicFormCoreModule {
}
